import React, { ReactNode } from 'react';
import { Container as BootstrapContainer } from 'react-bootstrap';
import './CustomContainer.css';

interface ContainerProps {
    children: ReactNode;
}

const CustomContainer: React.FC<ContainerProps> = ({
    children
}) => {
    return (
        <div className="container-wrapper">
            <BootstrapContainer>
                {children}
            </BootstrapContainer>
        </div>
    );
};

export default CustomContainer;